import { Component, Input, input, output } from '@angular/core';
import { BrandingState } from '../../../branding/store/branding.state';
import { ProfileTypeString } from '../../../profile/store/profile.entity';

import { TranslationComponent } from '../../../../providers/translate/component/translation.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-branded-header',
    templateUrl: './branded-header.component.html',
    styleUrls: ['./branded-header.component.scss'],
    imports: [TranslationComponent, TranslatePipe]
})
export class BrandedHeaderComponent {
    readonly profileType = input<ProfileTypeString>(undefined);
    @Input() brandingSettings: BrandingState;
    readonly helpClicked = output();

    constructor() {
    }

    helpedClickHandler(): void {
        this.helpClicked.emit();
    }
}
